export const auditCompanies = [
  {
    id: "premier",
    name: "Premier Roof Care LLC",
    location: "Austin, TX",
    region: "Texas",
    domain: "premierroofcare.com",
    auditStatus: "AUDITED (Q3 2026)",
    response: "3 hours 45 minutes",
    rank: "Bottom 18% (Grade: F)",
    leakage: "$48,000 / mo",
    diagnosis:
      "High risk of lead decay. 78% of your inbound leads hire a faster competitor before your team picks up the phone.",
    listed: false,
  },
  {
    id: "apex",
    name: "Apex Roofing Solutions",
    location: "Austin, TX",
    region: "Texas",
    domain: "apexroofing.com",
    auditStatus: "AUDITED (Q3 2026)",
    response: "18 seconds",
    rank: "Top 0.12% (Grade A+)",
    leakage: "+$84k/mo Captured",
    testTime: "02:14 PM",
    passing: true,
    listed: true,
  },
  {
    id: "sunstate",
    name: "SunState Roofers",
    location: "Orlando, FL",
    region: "Florida",
    domain: "sunstateroofers.com",
    auditStatus: "AUDITED (Q3 2026)",
    response: "4h 12m",
    rank: "Failed (Grade F)",
    leakage: "-$45k/mo Lost",
    testTime: "11:30 AM",
    passing: false,
    listed: true,
  },
  {
    id: "lonestar",
    name: "Lone Star Exteriors",
    location: "Houston, TX",
    region: "Texas",
    domain: "lonestarexteriors.com",
    auditStatus: "AUDITED (Q3 2026)",
    response: "No Reply (24h+)",
    rank: "Critical Leakage",
    leakage: "-$78k/mo Lost",
    testTime: "08:45 PM",
    passing: false,
    listed: true,
  },
  {
    id: "coastal",
    name: "Coastal Ridge Roofing",
    location: "Sydney, AU",
    region: "Australia",
    domain: "coastalridgeroofing.com.au",
    auditStatus: "AUDITED (Q3 2026)",
    response: "24 seconds",
    rank: "Top 0.12% (Grade A+)",
    leakage: "+$62k/mo Captured",
    testTime: "05:15 PM",
    passing: true,
    listed: true,
  },
]

export const searchCopy = {
  title: "Find Your Company in the 1,201 Audit Database",
  placeholder:
    "[ Enter your Company Name, Domain, or City... (e.g., Apex Roofing / Austin) ]",
  button: "Search",
  foundCta: "STANCH THIS LEAKAGE — RUN LIVE TEST NOW",
  missingTitle: "Company Not Found in the Initial 1,201 Benchmark Batch",
  missingBody:
    "Your business was not included in our initial blind audit. Run a Live 60-Second Speed Audit on your website right now for FREE:",
  domainLabel: "Your Website Domain",
  domainPlaceholder: "e.g. myroofing.com",
  phoneLabel: "Your Direct Mobile Phone",
  phonePlaceholder: "+1 (555) 000-0000",
  missingCta: "PREVENT THE LEAD LEAKAGE — BE IN TOP 0.12% OF ROOFING INDUSTRY",
}
